module.exports = __webpack_public_path__ + "static/media/hakusteel-1.09398eb8.png";